import React from 'react';
import { Popover, Heading, Paragraph, Box, DetailedIconCalculatorMoney, Text, Flex, Popper } from '@zillow/constellation';
import { commaSeparateNumber } from '../../utils/zhl-calculator.js';
import { useLastValidCashOutRefinanceValues, OUTPUTS, cashOutputs, getResult } from './CashOutRefinanceCalculator.utils.js';

var monthlyPaymentPopover = /*#__PURE__*/React.createElement(Popover, {
  header: /*#__PURE__*/React.createElement(Heading, {
    level: 6
  }, "New monthly payment"),
  body: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Paragraph, null, "This is the principal and interest payment based on your new loan balance. Your monthly payment may also include property taxes, homeowners insurance and mortgage insurance premiums, which are not shown in this estimate."))
});
var CashOutRefinanceContent = function CashOutRefinanceContent() {
  var lastValidCashOutRefinanceValues = useLastValidCashOutRefinanceValues();
  var _lastValidCashOutRefi = lastValidCashOutRefinanceValues.calculations,
    EstimatedMaxCashOutAmount = _lastValidCashOutRefi.EstimatedMaxCashOutAmount,
    combinedLoanToValue = _lastValidCashOutRefi.combinedLoanToValue,
    adjustedCashOutEstimate = _lastValidCashOutRefi.adjustedCashOutEstimate;
  return EstimatedMaxCashOutAmount <= 0 || combinedLoanToValue > 80 || adjustedCashOutEstimate <= 0 ? /*#__PURE__*/React.createElement(Box, {
    sx: {
      display: 'flex',
      justifyContent: 'center',
      flexDirection: 'column',
      alignItems: 'center',
      margin: '$spacing.md',
      background: '$colors.backgroundBlue',
      height: '300px'
    }
  }, /*#__PURE__*/React.createElement(Box, {
    sx: {
      svg: {
        height: '75px!important',
        width: '75px!important'
      }
    }
  }, /*#__PURE__*/React.createElement(Paragraph, {
    fontType: "h1",
    marginTop: "md"
  }, /*#__PURE__*/React.createElement(DetailedIconCalculatorMoney, null))), /*#__PURE__*/React.createElement(Text, {
    marginTop: "md",
    fontType: "h5",
    as: "p",
    "font-weight": "normal",
    textAlign: "center"
  }, "You need more home equity to cash-out."), /*#__PURE__*/React.createElement(Box, {
    sx: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      margin: '$spacing.sm',
      maxWidth: '70%'
    }
  }, /*#__PURE__*/React.createElement(Text, {
    textAlign: "center"
  }, "Try paying down more of your principal to lower your loan-to-value (LTV). This will help you build up enough home equity for a cash-out refinance."))) : /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Flex, {
    flex: "1",
    alignItems: "center",
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
    marginTop: "lg",
    "aria-live": "polite",
    "aria-atomic": "true",
    width: "100%"
  }, /*#__PURE__*/React.createElement(Text, {
    fontType: "h4",
    as: "p",
    "font-weight": "Normal"
  }, "Estimated max cash-out amount"), /*#__PURE__*/React.createElement(Text, {
    fontColor: "green500",
    fontType: "h3",
    margin: "sm"
  }, "$", commaSeparateNumber(lastValidCashOutRefinanceValues.calculations.EstimatedMaxCashOutAmount)), OUTPUTS.map(function (label, index) {
    return /*#__PURE__*/React.createElement(Box, {
      sx: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        paddingBottom: '$spacing.sm',
        marginBottom: '$spacing.sm',
        borderBottom: index !== OUTPUTS.length - 1 ? "1px solid $colors.coolGray400" : null,
        width: '70%'
      },
      last: index === OUTPUTS.length - 1,
      key: index
    }, /*#__PURE__*/React.createElement(Paragraph, null, /*#__PURE__*/React.createElement(Box, {
      sx: {
        display: 'flex',
        flexDirection: 'row',
        marginBottom: '$spacing.xxs',
        gap: '$spacing.xxs'
      }
    }, label === cashOutputs.newMonthlyPayment && /*#__PURE__*/React.createElement(React.Fragment, null, label, /*#__PURE__*/React.createElement(Popper, {
      style: {
        alignSelf: 'center'
      },
      triggered: monthlyPaymentPopover
    })) || label)), /*#__PURE__*/React.createElement(Text, {
      fontType: "h4"
    }, getResult(label, lastValidCashOutRefinanceValues)));
  })));
};
var CashOutRefinanceContent$1 = CashOutRefinanceContent;

export { CashOutRefinanceContent$1 as default };
